/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import {  } from '@insticator/insticator-ui/dist/material';
import { ReactComponent as CommentIcon } from 'assets/icons/product-layout/comment.svg'
import { ReactComponent as TrendingNowIcon } from 'assets/icons/product-layout/trending-now.svg'
import { ReactComponent as ArticleSentimentIcon } from 'assets/icons/product-layout/article-sentiment.svg'
// styles
import injectSheet from 'react-jss'
import styles from './controlbar_styles'

/* ========== ~~~~~~~~~~ PRODUCT MANAGER: PAGE SETUP : PREVIEW CONTROL BAR ~~~~~~~~~~ ========== */
const ControlBar = injectSheet(styles)((props) => {

  const { products = [], alignment, placement, showCommenting, showTrendingNow, showArticleSentiment,  onSelect } = props
  if(!showCommenting && !showTrendingNow && !showArticleSentiment) return null
  return (
    <div className={`controlbar ${props.classes.controlbar} ${placement || 'RIGHT_EDGE'}_PLACEMENT ${alignment || 'TOP'}_ALIGNMENT`}>
      <Space direction={'column'} gap={16} justifyContent={'center'} alignItems={'center'}>
        {products.map(product => (
          <>
            {product === 'COMMENTING_V2' && showCommenting && <Space klass={'icons'}><CommentIcon width={18} height={18} onClick={() => onSelect(product)} />128</Space>}
            {product === 'ARTICLE_SENTIMENT_V2' && showArticleSentiment && <Space klass={'icons'}><ArticleSentimentIcon width={18} height={18} onClick={() => onSelect(product)} />1.7k</Space>}
            {product === 'TRENDING_NOW_V2' && showTrendingNow && <Space klass={'icons'}><TrendingNowIcon width={20} height={20} onClick={() => onSelect(product)} /></Space>}
          </>
        ))}
      </Space>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ControlBar;
